import { SVGProps } from "react";

export default function DownloadIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 14, width = 14, fill = "#F6F3EF", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.52344 1.92539C7.52344 1.63544 7.28839 1.40039 6.99844 1.40039C6.70849 1.40039 6.47344 1.63544 6.47344 1.92539V7.9549L4.40512 5.76491C4.20603 5.55412 3.87376 5.54462 3.66296 5.74371C3.45216 5.94279 3.44267 6.27507 3.64176 6.48587L6.61676 9.63587C6.71593 9.74088 6.854 9.80039 6.99844 9.80039C7.14288 9.80039 7.28094 9.74088 7.38012 9.63587L10.3551 6.48587C10.5542 6.27507 10.5447 5.94279 10.3339 5.74371C10.1231 5.54462 9.79084 5.55412 9.59176 5.76491L7.52344 7.9549V1.92539Z"
        fill={fill}
      />
      <path
        d="M2.44844 8.92539C2.44844 8.63544 2.21339 8.40039 1.92344 8.40039C1.63349 8.40039 1.39844 8.63544 1.39844 8.92539V10.6754C1.39844 11.7385 2.26029 12.6004 3.32344 12.6004H10.6734C11.7366 12.6004 12.5984 11.7385 12.5984 10.6754V8.92539C12.5984 8.63544 12.3634 8.40039 12.0734 8.40039C11.7835 8.40039 11.5484 8.63544 11.5484 8.92539V10.6754C11.5484 11.1586 11.1567 11.5504 10.6734 11.5504H3.32344C2.84019 11.5504 2.44844 11.1586 2.44844 10.6754V8.92539Z"
        fill={fill}
      />
    </svg>
  );
}
